// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__gNR9K","content":"style_content__7MyFN","button":"style_button__eFx-m","title":"style_title__W1XaW","info":"style_info__E1yLj"};